/**
 * Angular imports
 */
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Module imports
 */
import { CarouselModule } from 'ngx-owl-carousel-o';

/**
 * Component imports
 */
import { ConnectionSuggFilterComponent } from './connection-sugg-filter.component';



@NgModule({
  declarations: [
    ConnectionSuggFilterComponent
  ],
  imports: [
    CommonModule,
    CarouselModule,
    FormsModule
  ],
  exports: [
    ConnectionSuggFilterComponent
  ]
})
export class ConnectionSuggFilterModule { }
